import script from "./RecoverVideoMethodSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecoverVideoMethodSelector.vue?vue&type=script&setup=true&lang=ts"

import "./RecoverVideoMethodSelector.vue?vue&type=style&index=0&id=77dff6f2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77dff6f2"]])

export default __exports__